<template>
    <v-dialog v-model="mostrar" persistent width="500px" fullscreen>
        <v-card :loading="loading">
             <v-toolbar color="blue-grey darken-2" dark>
                <v-toolbar-title>Agregar expedientes a transferencia</v-toolbar-title>
                 <v-spacer> </v-spacer>
                <v-btn outlined text dark @click="$emit('cancelar')" :disabled="loading" :loading="loading">Cancelar</v-btn>
                </v-toolbar>
           
            <v-card-text>
                <v-container>
                    <v-col>
                        <v-text-field
                            style="padding-top: 15px"
                            v-model="busqueda"
                            name="Emisor-nombre"
                            label="Buscar por clave de expediente"
                            outlined
                            @input="buscarExpediente()"
                        >
                        </v-text-field>
                    </v-col>
                    <v-data-table
                        v-if="expedientes.length"
                        :headers="headers"
                        :items="expedientesLista"
                        class="elevation-1"
                        :items-per-page.sync="page"
                        :footer-props="{
                            'items-per-page-all-text':'Todos',
                            'items-per-page-text':'Columnas'
                        }"
                    >
                     <template v-slot:body="{ items }">
                            <tbody>
                            <tr v-for="item in items" :key="item.name">
                       <td>{{item.clave}}</td>
                       <td>{{item.unidadAdministrativa.nombre}}</td>
                        <td>{{fecha(item.fechaCierre)}}</td>
                    
                        <td>
                        <v-btn color="blue-grey darken-2" dark @click="addTransferencia(item._id)" :disabled="loading" :loading="loading">
                            Agregar a transferencia
                        </v-btn>
                        </td>
                            </tr>
                            </tbody>
                     </template>
                    </v-data-table>
                    
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
       
</template>

<script>
import { buscarExpedientesService } from './archivo.service'
import { agregaraTransferencia } from './transferencias.service'
import { DateTime } from 'luxon'
export default {
    props:['mostrar','transferencia'],
    components: {

    },
    data: () => ({
        loading: false,
        expedientes:[],
        search:'',
        headers: [
            { text: 'Clave', value: 'clave' },
            { text: 'Unidad administrativa', value: 'unidadAdministrativa.nombre' },
            { text: 'Fecha de cierre', value: 'fechaCierre' },
            { text: '', value: 'opt'  }
           
        ],
        page:20,
        agregar:false,
        busqueda:'',
        expedientesTransferencia:[]
       
    }),
    computed: {
        expedientesLista(){
            let lista = []
            if(this.expedientes.length){
                if(this.transferencia.expedientes.length){
                    this.expedientes.forEach(y=>{
                        let index = this.transferencia.expedientes.findIndex(x=>x == y._id)
                        if(index==-1) lista.push(y)
                    })
                }
            }
            return lista;
        }
    },
    methods: {
        async buscarExpediente(){
            try{
                this.loading=true
                const serverResponse = await buscarExpedientesService(this.busqueda)
                this.loading = false
                if(!serverResponse) throw new Error(serverResponse.mensaje);
                this.expedientes= serverResponse.expedientes

            }catch(e){
                this.$notificarError(e)

            }
        },

        async addTransferencia(id){
            try{
                this.loading=true
                const serverResponse = await agregaraTransferencia(this.transferencia._id, id)
                this.loading = false
                if(!serverResponse) throw new Error(serverResponse.mensaje);
                this.$emit('expeAgregado', {id, idTransferencia:this.transferencia._id})

            }catch(e){
                this.$notificarError(e)

            }
        },
        fecha(fecha){
            return DateTime.fromISO(fecha).toFormat('dd - MM - yyyy')
        },
        
    }
}
</script>